import { Component, Input } from '@angular/core';
import { Product } from '@spartacus/core';

@Component({
  selector: 'app-custom-simple-product-item',
  templateUrl: './custom-simple-product-item.component.html',
  standalone: false
})
export class CustomSimpleProductItemComponent {
  @Input() item: Product;
  @Input() pdp: boolean;

  constructor() {}
}
